

import {
  Container,
  Title,
  Text,
  Card,
  Badge,
  Group,
  SimpleGrid,
  ThemeIcon,
} from '@mantine/core';
import {
  IconUser,
  IconBook2,
  IconMap,
  IconMapPin,
} from '@tabler/icons-react';

import { useNavigate } from 'react-router-dom';



const LOOKUP_GROUPS = [
  {
    id: 'acts-care-courses',
    title: 'Acts Care Courses',
    description: 'Manage course, session, and registration statuses',
    icon: IconBook2,
    color: 'blue',
    count: 5,
    link: '/LookUp/ActsCareCourses',
  },
  {
    id: 'acts-care-counseling',
    title: 'Acts Care Counseling',
    description: 'Manage case types, session types, and leader roles',
    icon: IconUser,
    color: 'teal',
    count: 5,
    link: '/LookUp/ActsCareCounseling',
  },
  {
    id: 'Location',
    title: 'Location',
    description: 'Manage Zones, and Areas',
    icon: IconMapPin,
    color: 'yellow',
    count: 2,
    link: '/LookUp/Location',
  },
];

export default function LookUpPage() {
  const navigate = useNavigate();


  return (
    <Container size="xl" py="xl">
      <Group gap="sm" mb={4}>
        <Title order={2}>Lookup Management</Title>
      </Group>
      <Text c="dimmed" mb="xl">
        Manage course statuses, facilitator statuses, session types, and more
      </Text>

      <SimpleGrid cols={{ base: 1, sm: 2 }} spacing="md">
        {LOOKUP_GROUPS.map((group) => (
          <Card
            key={group.id}
            shadow="sm"
            padding="lg"
            radius="md"
            withBorder
            style={{ cursor: 'pointer' }}
            onClick={() => navigate(group.link)}
          >
            <Group justify="space-between" wrap="nowrap">
              <Group gap="md">
                <ThemeIcon variant="light" color={group.color} size="lg" radius="md">
                  <group.icon size={18} />
                </ThemeIcon>
                <div>
                  <Text fw={600}>{group.title}</Text>
                  <Text size="xs" c="dimmed">{group.count} lookups</Text>
                </div>
              </Group>
              <Badge color={group.color} variant="filled" circle size="lg">
                {group.count}
              </Badge>
            </Group>
          </Card>
        ))}
      </SimpleGrid>
    </Container>
  );
}
